import React, { Component } from 'react'

class NH extends Component {
  render() {
    return (
      <symbol id="statesvg-NH" width="100" height="100" viewBox="0 0 100 100">
        <path d="M64.82,2.78,68.75,66.6,68,73l4.31,5.66v3.2l2.33,3-.36.86,1.35-.25V86l-2.71,6.39-3.19-.24-4.06,2.7h-2l-1.6,2.34-2.83,2L26.94,98.08l-2.46-3.94-.12-1.72L25.47,89l1.23-1.35,1-9.47,1-1.48L29,66.85l1.85-2,.74-4.18,2.58-2.46.74-3.69,2.33-3.44L36.78,50l1.72-3.69.37-6.76,1.6-2.22L44,37.09l4.67-3.94,2-2.46.37-2.09L52.27,28l-2.33-5.78,3.32-5.9-.62-3.94L56,4.5l-1-.86,3.44-2.46L62.48,3l2-2.22Z" />
      </symbol>
    )
  }
}

export default NH
